import React from "react";
import { useOutletContext } from "react-router-dom";
import {
    GleapHero,
    GleapTrustStrip,
    MetricsBar,
    FourCapabilities,
    OneCore,
    WhyNyra,
    BigImpactCard,
    GleapFAQ,
    FinalCTA,
    IntegrationsHub,
    CompanyStatement,
    CapabilityMatrix,
} from "@/components/site/GleapSections";
import { TestimonialCarousel } from "@/components/site/TestimonialCarousel";
import { ProductTour } from "@/components/site/ProductTour";

export default function Home() {
    const { openDemo } = useOutletContext();

    return (
        <div className="bg-warm">
            {/* 1 — Hero */}
            <GleapHero openDemo={openDemo} />

            {/* 2 — Metrics bar */}
            <MetricsBar />

            {/* 3 — Trust marquee */}
            <GleapTrustStrip />

            {/* 3b — Company statement + inline stats (Botpress-style) */}
            <CompanyStatement />

            {/* 4 — Four capabilities (Engage · Act · Orchestrate · Evaluate) */}
            <FourCapabilities openDemo={openDemo} />

            {/* 5 — Kore.ai-style capability matrix (Leverage AI with AI) */}
            <CapabilityMatrix />

            {/* 5b — Product tour (recreated console screens, demo data) */}
            <ProductTour />

            {/* 6 — One core underneath everything */}
            <OneCore />

            {/* 7 — Big impact split card */}
            <BigImpactCard />

            {/* 10 — Why teams consolidate on Nyra */}
            <WhyNyra />

            {/* 12b — Customer testimonial carousel (anonymized archetypes) */}
            <TestimonialCarousel />

            {/* 13 — Integrations hub */}
            <IntegrationsHub />

            {/* 16 — FAQ */}
            <GleapFAQ />

            {/* 17 — Final CTA */}
            <FinalCTA openDemo={openDemo} />
        </div>
    );
}
